// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepbody {
  background-color: #2c68ad;
  height: 100vh;
}

.stepheading {
  color: white;
  margin: 0;
  line-height: 1.3;
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px 8px;
}

.sidebar-header .language-switcher {
  width: auto;
  min-width: 92px;
}

.sidebar-header .language-switcher__trigger {
  width: 100%;
  margin-top: 0;
  padding: 0 10px;
  height: 38px;
  gap: 6px;
}

.step-name {
  color: white;
}

.nextbutton {
  background-color: #fff !important;
  width: 100%;
  min-width: 160px;
}

@media (max-width: 991px) {
  .stepbody {
    height: auto;
    padding-bottom: 20px;
  }
  .sidebar-header {
    flex-wrap: wrap;
    align-items: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/OnboardingSidebar/OnboardignSidebar.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,aAAA;AACJ;;AACA;EACI,YAAA;EACA,SAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,sBAAA;AAGJ;;AADA;EACI,WAAA;EACA,eAAA;AAIJ;;AAFA;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;AAKJ;;AAHA;EACI,YAAA;AAMJ;;AAJA;EACI,iCAAA;EACA,WAAA;EACA,gBAAA;AAOJ;;AAJA;EACI;IACI,YAAA;IACA,oBAAA;EAON;EALE;IACI,eAAA;IACA,mBAAA;EAON;AACF","sourcesContent":[".stepbody{\n    background-color: #2c68ad;\n    height: 100vh;\n}\n.stepheading{\n    color: white;\n    margin: 0;\n    line-height: 1.3;\n}\n.sidebar-header{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 16px 20px 8px;\n}\n.sidebar-header .language-switcher {\n    width: auto;\n    min-width: 92px;\n}\n.sidebar-header .language-switcher__trigger {\n    width: 100%;\n    margin-top: 0;\n    padding: 0 10px;\n    height: 38px;\n    gap: 6px;\n}\n.step-name{\n    color: white;\n}\n.nextbutton{\n    background-color: #fff !important;\n    width: 100%;\n    min-width: 160px;\n}\n\n@media (max-width: 991px) {\n    .stepbody{\n        height: auto;\n        padding-bottom: 20px;\n    }\n    .sidebar-header{\n        flex-wrap: wrap;\n        align-items: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
